// extracted by mini-css-extract-plugin
export var auteurName = "index-module--auteur-name--UVNkp";
export var auteurJobTitle = "index-module--auteur-jobTitle--GP74h";
export var auteurFoto = "index-module--auteur-foto--X44nk";